import { stratosGreenColor } from "src/constants/colors";
import styled from "styled-components";

export const FooterLabel = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  span {
    color: rgba(255, 255, 255, 1);
    opacity: 0.3;
  }
`;

export const FooterContainer = styled.div<{ $backgroundColor?: string }>`
  width: 85%;
  height: 120px;
  max-width: 1400px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: ${({ $backgroundColor }) => {
    return $backgroundColor ? $backgroundColor : "transparent";
  }};
  &.mobile_menu {
    align-items: flex-start;
    flex-direction: column;
    height: auto;
  }
`;

export const FooterLeft = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  flex-grow: 3;

  &.mobile_menu {
    align-items: flex-start;
    margin-bottom: 8px;
  }
`;

export const FooterLogo = styled.div`
  display: flex;
  align-items: center;
  flex-grow: 3;

  &.mobile_menu {
    margin-bottom: 8px;
  }
`;

export const LogoImageContainer = styled.div`
  cursor: pointer;
  height: 40px;
  align-items: center;
  display: flex;
  img {
    width: 120px;
  }
`;

export const FooterRight = styled.div`
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  align-items: flex-end;
  padding-right: 2rem;
  gap: 1rem;
  &.mobile_menu {
    /* padding-top: 8px; */
    padding-bottom: 8px;
    gap: 8px;
    align-items: flex-start;
    padding-right: 0;
    margin-bottom: 8px;
    margin-top: 24px;
  }
`;

export const SocialLinks = styled.div`
  flex-grow: 1;
  gap: 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const NavigationMenu = styled.div`
  flex-grow: 2;
  display: flex;
  align-items: center;

  &.mobile_menu {
    flex-direction: column;
    align-items: flex-start;
    gap: 5px;
  }
  a {
    text-decoration: none;
    margin: 0 1rem 0 0;

    text-align: center;
    span {
      color: #fff;
      &.active {
        color: ${stratosGreenColor};
      }

      &:hover {
        background-color: transparent;
        color: ${stratosGreenColor};
      }
    }
  }
`;

export const NavigationSubMenu = styled.div`
  flex-grow: 2;
  display: flex;
  align-items: center;

  gap: 1rem;

  a {
    text-decoration: none;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;

    text-align: center;
    span {
      color: rgba(255, 255, 255, 1);
      opacity: 0.3;

      &.active {
        color: ${stratosGreenColor};
      }

      &:hover {
        background-color: transparent;
        color: ${stratosGreenColor};
      }
    }
  }
`;
